import SearchModalPodcastEpisodeList from './SearchModalPodcastEpisodeList';

export default SearchModalPodcastEpisodeList;
